import React, { createContext, useContext, useState } from 'react'

import { HookData } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/types/data'

interface Props {
  children: React.ReactNode
}

interface CachedData {
  [key: string]: HookData
}

interface IValue {
  data: CachedData
  setData: (data: CachedData) => void
}

const CachedDataContext = createContext<IValue | undefined>(undefined)

export const CachedDataProvider: React.FC<Props> = ({ children }) => {
  const [data, setData] = useState<CachedData>({})

  return (
    <CachedDataContext.Provider value={{ data, setData }}>{children}</CachedDataContext.Provider>
  )
}

export const useCachedData = () => {
  const context = useContext(CachedDataContext)
  if (context === undefined) {
    throw new Error('useCachedData must be used within a CachedDataProvider')
  }
  return context
}
